import React, { useState, useEffect, forwardRef } from 'react';

import calendarService from '../../services/CalendarService';

import Button from 'react-bootstrap/Button';
import Modal from "react-bootstrap/Modal";
import liveRoomService from "../../services/LiveRoomService";


import 'react-bootstrap-typeahead/css/Typeahead.css';

const CompleteTrainingModal = (props) => {

    const {
        show,
        onHide,
        bureauMatchId,
        selectedFixtureActive,
        selectedFixtureRoomId,
        setSelectedFixtureActive,
        isRoomActive,
        setIsRoomActive,
        userId
    } = props;

    const [errorMessage, setErrorMessage] = useState(null);
    const [fixtureDetails, setFixtureDetails] = useState(null);

    useEffect(() => {
        if (!fixtureDetails || fixtureDetails.bureauMatchId != bureauMatchId) {
            setFixtureDetails(null);
            calendarService.getFixtureDetails(bureauMatchId).then((fixtureDetails) => {
                setFixtureDetails(fixtureDetails);
            });
        }
    }, [bureauMatchId]);

    const handleEndRoom = async () => {
        await liveRoomService.endRoom(selectedFixtureRoomId, userId);
    }
    const handleReOpen = async () => {
        await liveRoomService.reopenRoom(selectedFixtureRoomId);
    }
    let errorLabel =
        errorMessage && errorMessage.length > 0 ? (
            <span className="text-danger">{errorMessage}</span>
        ) : (
            <></>
        );
    const isReviewedOnChangeHandle = async () => {
        let updatedList = isRoomActive.map(item => {
            if (item.fixtureRoomId === selectedFixtureRoomId) {
                return {...item, key: !item.key}
            }
            return item;
        });
        await setSelectedFixtureActive((current) => !current);
        await setIsRoomActive(updatedList);
    }
    return (
        <Modal
            show={show}
            onHide={onHide}
            backdrop="static"
            centered
            size="lg"
        >
            <Modal.Header>
                <Modal.Title>
                    <h4>
                        {selectedFixtureActive ? 'Mark Training game as complete' : 'Are you sure you want to mark training game as incomplete ? '}
                    </h4>
                    <h6>
                        {errorLabel}
                    </h6>
                </Modal.Title>
            </Modal.Header>
            <Modal.Footer>
                <Button variant="primary" onClick={() => {
                    onHide();
                    setErrorMessage(null);
                }}>Close</Button>
                <Button variant="danger" onClick={async () => {
                    if (selectedFixtureRoomId !== null) {
                        selectedFixtureActive ? handleEndRoom() : handleReOpen();
                        await isReviewedOnChangeHandle();
                        onHide();
                    } else {
                        setErrorMessage("Fixture Room is not exist");
                    }
                }}>Confirm</Button>
            </Modal.Footer>
        </Modal>
    )

};

export default CompleteTrainingModal;